import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import ROUTES from "../app/routes";
import Swal from "sweetalert2";
// import selectors
import { selectTopics } from "../features/topics/topicsSlice";
import { selectQuizzes } from "../features/quizzes/quizzesSlice";

import { addQuiz } from "../features/quizzes/quizzesSlice";
import { addCard } from "../features/cards/cardsSlice";

export default function NewQuizForm() {
  const [name, setName] = useState("");
  const [cards, setCards] = useState([]);
  const [topicId, setTopicId] = useState("");
  const navigate = useNavigate();
  const topics = useSelector(selectTopics);
  const quizzes = useSelector(selectQuizzes);
  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (name.length === 0) {
      Swal.fire({
        title: "Name your new Quizz",
        input: "text",
        inputLabel: "Quizz Name:",
        icon: "warning",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "You need to write something!";
          } else if (value) {
            setName(value);
          }
        }
      });
      return;
    } else if (!topicId) {
      Swal.fire({
        title: "Select a Topic from the List",
        icon: "warning",
        showCancelButton: true,
      });
      return;
    } else if (Object.keys(quizzes).includes(name)) {
      Swal.fire({
        title: "Quiz Name Already Exists",
        input: "text",
        inputLabel: "New Quiz Name:",
        icon: "warning",
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return "You need to write something!";
          } else if (value) {
            setName(value);
          }
        }
      });
      return;
    } else if (cards.length === 0) {
      Swal.fire({
        title: "Add some cards to your quiz",
        icon: "warning",
        showCancelButton: true,
      });
      return;
    }

    const cardIds = [];

    // create the new cards here and add each card's id to cardIds
    cards.forEach((card) => {
      const cardId = uuidv4();
      cardIds.push(cardId);
      dispatch(addCard({ id: cardId, front: card.front, back: card.back }))
    })

    // create the new quiz here

    const quizId = uuidv4();

    // dispatch add quiz action 
    dispatch(addQuiz({ id: quizId, name, topicId, cardIds, icon: topics[topicId].icon, topicName: topics[topicId].name }));

    navigate(ROUTES.quizzesRoute())
  };

  const addCardInputs = (e) => {
    e.preventDefault();
    setCards(cards.concat({ front: "", back: "" }));
  };

  const removeCard = (e, index) => {
    e.preventDefault();
    setCards(cards.filter((card, i) => index !== i));
  };

  const updateCardState = (index, side, value) => {
    const newCards = cards.slice();
    newCards[index][side] = value;
    setCards(newCards);
  };

  return (
    <section>
      <h1>Create a new quiz</h1>
      <form onSubmit={handleSubmit}>
        <input
          id="quiz-name"
          value={name}
          onChange={(e) => setName(e.currentTarget.value)}
          placeholder="Quiz Title"
          className="webInput"
        />
        <select
          id="quiz-topic"
          onChange={(e) => setTopicId(e.currentTarget.value)}
          placeholder="Topic"
          className="webSelect"
        >
          <option value="">Topic</option>
          {Object.values(topics).map((topic) => (
            <option key={topic.id} value={topic.name}>
              {topic.name}
            </option>
          ))}
        </select>
        {cards.map((card, index) => (
          <div key={index} className="card-front-back">
            <input
              id={`card-front-${index}`}
              value={cards[index].front}
              onChange={(e) =>
                updateCardState(index, "front", e.currentTarget.value)
              }
              placeholder="Front"
              className="webInput"
            />

            <input
              id={`card-back-${index}`}
              value={cards[index].back}
              onChange={(e) =>
                updateCardState(index, "back", e.currentTarget.value)
              }
              placeholder="Back"
              className="webInput"
            />

            <button
              onClick={(e) => removeCard(e, index)}
              className="remove-card-button"
            >
              Remove Card
            </button>
          </div>
        ))}
        <div className="actions-container">
          <button onClick={addCardInputs}>Add a Card</button>
          <button type="submit">Create Quiz</button>
        </div>
      </form>
    </section>
  );
}
